import { OptionType } from '../AutoComplete';

import {
  DemoRequestFormValues,
  FeedbackFormValues,
  TaskRequestFormValues,
} from './types';

export const CHANGE_REQUEST_MODAL_ID = 'CHANGE_REQUEST_MODAL';
export const FEEDBACK_REQUEST_TYPE = 'feedback';
export const DEMO_REQUEST_TYPE = 'demo';

export const TASK_REQUEST_TYPES = [
  'Bug',
  'Change Request',
  'New Feature',
  'Data Issue',
  'Question',
];

export const REQUEST_TYPE_OPTIONS: OptionType[] = [
  ...TASK_REQUEST_TYPES.map((requestType) => ({
    value: requestType,
    label: requestType,
  })),
  { value: FEEDBACK_REQUEST_TYPE, label: 'Feedback' },
  { value: DEMO_REQUEST_TYPE, label: 'Request a Demo' },
];

export const TASK_DEFAULT_VALUES: TaskRequestFormValues = {
  report_title: '',
  report_description: '',
  error_message: '',
  additional_context: '',
};

export const FEEDBACK_DEFAULT_VALUES: FeedbackFormValues = {
  feedback: '',
};

export const DEMO_DEFAULT_VALUES: DemoRequestFormValues = {
  date_range: [null, null],
  time_selection: null,
  topic: '',
  emails: '',
};

export const DEMO_TIME_OPTIONS: OptionType[] = [
  '08:00 GMT',
  '09:00 GMT',
  '10:00 GMT',
  '11:00 GMT',
  '12:00 GMT',
  '13:00 GMT',
  '14:00 GMT',
  '15:00 GMT',
  '16:00 GMT',
  '17:00 GMT',
].map((time) => ({ value: time, label: time }));

// Blank, or a comma separated list of email addresses.
export const EMAIL_LIST_PATTERN =
  /^\s*$|^\s*[^\s@,]+@[^\s@,]+\.[^\s@,]+(\s*,\s*[^\s@,]+@[^\s@,]+\.[^\s@,]+)*\s*$/;

export const EMAIL_LIST_ERROR_TEXT =
  'Enter valid email addresses separated by commas';

export const DATE_RANGE_ERROR_TEXT = 'Select a start and an end date';

// The backend serializer rejects a blank error_message, so an empty field is
// sent as this placeholder instead.
export const NO_ERROR_MESSAGE = 'Not specified';

export const MAX_ATTACHMENT_SIZE = 26214400; // 25mb
